import { useEContext } from '../../shared/components/EContext';
import { useHistory } from 'react-router-dom';
import useAppSettings from '../../shared/hooks/useAppSettings';

export function useInboxHanger(): [boolean, () => void] {
    const { identity } = useEContext();
    const history = useHistory();
    const showHangerSettings = useAppSettings('inboxhangar');

    const fetchedSetting = !showHangerSettings.loading;
    const isHangerDismissed =
        showHangerSettings.data && showHangerSettings.data.content && showHangerSettings.data.content.isHangerDismissed;
    const notOnHomePage = history.location.pathname !== '/home';
    const hasInboxHangerFeatureFlag = identity?.session.features.inboxHanger;

    const showHanger = fetchedSetting && !isHangerDismissed && notOnHomePage && hasInboxHangerFeatureFlag;

    function hideHanger() {
        showHangerSettings.set({ isHangerDismissed: true });
    }

    return [showHanger, hideHanger];
}
